export default "__VITE_ASSET__I7DO_Uns__"